import { api } from '../../api';
import { ApiResponse } from '../Utilities';
import { RuleViewModel } from '../ViewModels';

export class RuleApi {
    private route = '/Rule';

    public getRule({ params }: { params: { ruleSetName: string } }): ApiResponse<RuleViewModel[]> {
        return api().get(this.route, { params });
    }
}

